









































import Vue from 'vue';
import { Table, Header, HeaderCell, Row, Cell, Pagination } from '@aergoenterprise/lib-components/src/composite/tables';
import TableController from '@aergoenterprise/lib-components/src/container/TableController.vue';
import { LoadArgs } from '@aergoenterprise/lib-components/src/container/TableController.types';
import { Vertical } from '@aergoenterprise/lib-components/src/layout';
import { Rest } from '@aergoenterprise/lib-components/src/container';
import { formatDistance, format } from 'date-fns';
import { Amount } from '@herajs/client';
import { chains } from '../config.json';
import { mapState } from "vuex";

export default Vue.extend({
  components: {
    Table, Header, HeaderCell, Row, Cell,
    TableController, Pagination,
    Vertical,
    Rest,
  },
  props: {
    address: String,
  },
  data() {
    return {
      isLoading: false,
      restInput: {
        address: `${this.address}`,
        sort: 'no:desc',
        size: 20,
        from: 0,
      },
    };
  },
  computed: {
    ...mapState(['activeChainId']),
    endpoint(): string {
      if (!this.activeChainId) return '';
      const chainConfig = chains[this.activeChainId.chainid.magic as "aergo.io" | "testnet.aergo.io"];
      if (!chainConfig) return '';
      return `${chainConfig.api_endpoint}/rewards`;
    }
  },
  methods: {
    loadTableData({ sort, page }: LoadArgs): void {
      this.restInput.from = page.offset;
      this.restInput.sort = `${sort.field}:${sort.asc?'asc':'desc'}`;
    },
    dataLoaded(result: any): void {
      this.$emit('loaded', result);
    },
    formatTs(ts: string): string {
      const date = new Date(ts);
      const today = new Date();
      const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
      if (isToday) return 'Today until now';
      return format(date, 'yyyy-MM-dd');
    },
    calculateReward(count: number): Amount {
      return new Amount('0.16 aergo').mul(count);
    },
    reverse(arr: any[]): any[] {
      const copy = [...arr];
      return copy.reverse();
    }
  },
});
